import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=1f234af1&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"
import style0 from "./Header.vue?vue&type=style&index=0&id=1f234af1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f234af1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/publish/iot-cloud-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f234af1')) {
      api.createRecord('1f234af1', component.options)
    } else {
      api.reload('1f234af1', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=1f234af1&scoped=true", function () {
      api.rerender('1f234af1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Header.vue"
export default component.exports